import { useNavigate } from "react-router-dom";
import { Navbar } from "../../components/Navbar/Navbar";
import { SessionExpiredCard } from "../../components/SessionExpiredCard";
import { useEffect, useRef, useState } from "react";
import TableContentMaintenance from "../../components/TableContentMaintenance"; 

const DashboardMaintenance = () => {
    const token = localStorage.getItem("site");
    const navigate = useNavigate();
    const timeoutRef = useRef();
    const [isValidate, setIsValidate] = useState(true); 

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            {isValidate && (
                <>
                    <Navbar />
                    {/* Render the new table component */}
                    <TableContentMaintenance />
                </>
            )}
            {!isValidate && (
                <SessionExpiredCard />
            )}
        </>
    );
};

export default DashboardMaintenance;
